import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

/**
 * Строчка «Минимум 10 символов» под полем пароля в форме регистрации.
 *
 * Это подсказка, а не проверка: требование к паролю держит сервер, и форма без
 * этой строки защищена ровно так же. Она просто избавляет человека от отказа,
 * который легко было предвидеть.
 *
 * Остальные правила (не повторять имя и адрес, не брать распространённый
 * пароль) здесь не перечисляются: их четыре, списком они выглядят как
 * инструкция к договору, и человек всё равно узнаёт о нарушении из понятного
 * сообщения ровно тогда, когда оно его касается.
 */
export default function addPasswordHint() {
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    const group = items.get('password');
    if (!group || !Array.isArray(group.children)) return;
    group.children = [...group.children, m("p", {
      className: "helpText TpPasswordHint"
    }, app.translator.trans('tarotportal-theme.forum.password.hint'))];
  });
}